import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { createSelector } from 'reselect';
// import { setBrandPath, setClientPath, setMarketPath } from '../slices/auth/menu/reducer';
import { getMenuData, setBrandPath, setClientPath, setMarketPath } from '../slices/auth/menu/thunk';
import { Container, Row, Col } from 'reactstrap';
import { Spinner } from 'reactstrap';
import Preloader from '../Components/Common/Preloader';
import { getCampaigns } from '../slices/campaigns/thunk';
import { push } from "redux-first-history";
import { setPreloader } from '../slices/layouts/reducer';
import { setBreadcrumb, setCampaignPath, setLocationHook, setPushHook } from '../slices/auth/menu/reducer';
import { ToastContainer } from 'react-toastify';
import BreadCrumb from '../Components/Common/BreadCrumb';
import Cookies from 'js-cookie';

function RouteHandler() {
  const dispatch = useDispatch();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const selectMenuDataState = createSelector((state) => state, (state) => ({
    menuData: state.MenuData.client,
    clientPath: state.MenuData.clientPath,
    brandPath: state.MenuData.brandPath,
    marketPath: state.MenuData.marketPath,
    preloader: state.Layout.preloader,
    campaignLoader: state.Campaign.campaignLoader,
    pageTitle: state.MenuData.pageTitle,
    title: state.MenuData.title,
    previousLocations: state.router.previousLocations,
    isMaintenance: state.Login.isMaintenance,
    currentVersion: state.Campaign.currentVersion,
  }));
  const { 
    menuData, 
    clientPath, 
    brandPath, 
    marketPath, 
    preloader, 
    pageTitle, 
    campaignLoader, 
    title, 
    previousLocations, 
    isMaintenance,
    currentVersion,
  } = useSelector(selectMenuDataState);
 
  useEffect(() => {
    async function handleNav() {
      if (menuData !== null && menuData !== "") {
        if (params.client && params.brand) {
          const matchedClient = menuData.clients.find((item, idx) =>
            item.clientName.toLowerCase().replaceAll(/\s+/g, "-") === params.client
          );
          if (matchedClient) {
            await dispatch(setClientPath(matchedClient._id));
            if (params.brand) {
              let matchedBrand;
              if (Array.isArray(matchedClient.brands)) {
                matchedBrand = matchedClient.brands.find((item, idx) =>
                  item.name.toLowerCase().replaceAll(/\s+/g, "-") === params.brand
                );
              } else {
                matchedBrand = matchedClient.brands;
              }
              if (matchedBrand) {
                await dispatch(setBrandPath(matchedBrand._id));
                if (params.market) {
                  let matchedMarket;
                  if (Array.isArray(matchedBrand.markets)) {
                    matchedMarket = matchedBrand.markets.find((item, idx) =>
                      item.name.toLowerCase().replaceAll(/\s+/g, "-") === params.market
                    );
                  } else {
                    matchedMarket = matchedBrand.markets;
                  }
                  if (matchedMarket) {
                    await dispatch(setMarketPath(matchedMarket._id));
                  }
                } else {
                  dispatch(setMarketPath(null));
                }
                if (params.campaignId) {
                  dispatch(setCampaignPath(params.campaignId));
                }
              } else {
                navigateDefault();
              }
            } else {
              dispatch(setMarketPath(null));
              dispatch(setBrandPath(null));
            }
          } else {
            if (window.location.href.includes('analytics')) {
              dispatch(setClientPath('1'));
            } else {
              navigateDefault();
            }
          }
        } else {
          if (window.location.href.includes('analytics')) {
            const matchedClient = menuData.clients.find((item, idx) =>
              item.clientName.toLowerCase().replaceAll(/\s+/g, "-") === params.client
            );
            if (matchedClient) {
              await dispatch(setClientPath(matchedClient._id));
            }
          } else {
            navigateDefault();
          }
        }
      }
    }
    saveUserLastLocation();
    dispatch(setLocationHook(location));
    handleNav();
  }, [menuData, location]);

  async function navigateDefault() {
    try {
      const lastLocation = Cookies.get('lastLocation');
      if (previousLocations.length <= 2 && lastLocation && 
        !lastLocation.includes('maintenance') && 
        !lastLocation.includes('publish') && 
        !lastLocation.includes('analytics') && 
        !lastLocation.includes('out-of-permission')
      ) {
        dispatch(push(lastLocation));
      } else {
        const getFirstClient = menuData.clients[0];
        await dispatch(setClientPath(getFirstClient._id));
        const clientName = getFirstClient.clientName.toLowerCase().replaceAll(/\s+/g, "-");
        const getFirstBrand = getFirstClient.brands[0];
        await dispatch(setBrandPath(getFirstBrand._id));
        const brandName = getFirstBrand.name.toLowerCase().replaceAll(/\s+/g, "-");
        const getFirstMarket = (getFirstBrand.markets[0] || getFirstBrand.markets);
        await dispatch(setMarketPath(getFirstMarket._id));
        const marketName = getFirstMarket.name.toLowerCase().replaceAll(/\s+/g, "-");
        if (clientName, brandName, marketName) {
          dispatch(setPreloader(true));
          dispatch(getCampaigns()).then(res => {
            dispatch(push(`/${clientName}/${brandName}/${marketName}/campaigns/filter/all`, { campaigns: res.payload, title: [] }))
            dispatch(setPreloader(false));
          })
        } else {
          throw true;
        }
      }
    } catch (error) {
      dispatch(push(`/settings/personal-details`));
    }
  }

  function saveUserLastLocation() {
    if (previousLocations.length > 2) {
      if (params.campaignId && window.location.pathname.includes('campaigns/')) {
        Cookies.set('lastLocation', `${window.location.pathname.split('campaigns/')[0]}/campaigns/filter/all`, { expires: 2 });
      } else if (
        !window.location.pathname.includes('maintenance') && 
        !window.location.pathname.includes('publish') && 
        !window.location.pathname.includes('analytics') && 
        !window.location.pathname.includes('out-of-permission')
      ) {
        Cookies.set('lastLocation', window.location.href, { expires: 2 });
      }
    }
  };

  return (
    <React.Fragment>
      {isMaintenance ?
        <Navigate to={'/maintenance'} />
        :
        <React.Fragment>
          <ToastContainer closeButton={false} />
          {campaignLoader ?
            <Preloader />
            : null}
          {preloader ?
            <Preloader />
            :
            <div className='page-content'>
              <Container fluid>
                <Row>
                  <Col>
                    {window.location.href.includes('analytics') ?
                      <Outlet />
                      : marketPath !== undefined ?
                        <Outlet />
                        : null}
                  </Col>
                </Row>
              </Container>
            </div>
          }
        </React.Fragment>
      }
    </React.Fragment>
  )
}

export default RouteHandler;